export const industryValidation = {
    mandatory,
}
function mandatory(industry) {
    const errors = {}
    if (!industry.name) {
        errors.name = 'Industry Name is required'
    }
    if (!industry.sectorId) {
        errors.sectorId = 'Sector Name is required'
    }
    if (!industry.status ) {
        errors.status = 'Status is required'
    }
    if (!industry.sequence) {
        errors.sequence = 'Sequence is required'
    }
    else if (isNaN(industry.sequence)) {
        errors.sequence = 'Sequence should be in number'
    }
    return errors
}